import React, { useState, createContext } from "react"

export const FollowUpContext = createContext({
    constantDate: null,
    setConstantDate: () => {}
})

export default function FollowUpProvider(props) {
    const { children } = props
    const [constantDate, setConstantDate] = useState(null)

    return (
        <FollowUpContext.Provider
            value={{
                constantDate,
                setConstantDate
            }}
        >
            {children}
        </FollowUpContext.Provider>
    )
}
